export default __webpack_public_path__ + "static/media/recipe.db0f3824.png";